export enum ConfigurationNavKey {
  PROGRAM_CONFIG_HEADING = "updateConfigHeading",
  PROGRAM_SELECTION_CONFIG_HEADING = "updateSelectionConfigHeading",
  UPDATE_PROGRAM = "updateProgram",
  MEETUP_PROFILE = "meetupProfile",
  TABLETALK_TOPIC = "tabletalkTopic",
  TIMELINE_CONFIGURATION = "timelineConfiguration",
  SELECTION_CARD_CONFIGURATION = "selectionCardConfiguration"
}

export enum ProgramTimelineCopies {
  TIMELINES = "program.timelines",
  STAGE_SKIP = "program.timeline.skip.stage",
  TIMELINE_STATUS = "program.timeline.status",
  TIMEZONE_INFO = "program.timezone.info.msg",
  TRIGGER_TIME = "program.timeline.trigger.time",
  STAGE_CHANGE_TIME = "program.timeline.psc.time",
  EMAIL_SNIPPET = "program.timeline.email.snippet",
  STAGE_SKIPPED = "program.timeline.stage.skipped",
  STAGE_SKIP_INFO = "program.timeline.skip.stage.info",
  END_DATE_AFTER_START_DATE = "end.date.time.after.start",
  EMAIL_REMINDERS = "program.timeline.stage.email.trigger",
  ADD_REMINDER = "program.timeline.add.email.reminder.msg",
  STAGE_CHANGE_TIME_INFO = "program.timeline.psc.time.info",
  START_DATE_BEFORE_END_DATE = "start.date.time.before.end",
  TAB_DISABLED_INFO = "program.timeline.email.tab.disabled.info",
  STAGE_NOT_CONFIGURED = "program.timeline.stage.not.configured",
  UPDATE_SNIPPET = "program.timeline.update.snippet.content.heading",
  START_DATE_AFTER_STAGE_DATE = "stage.start.date.time.after.psc.date.time",
  STAGE_DATE_BEFORE_START_DATE = "psc.date.time.before.stage.start.date.time",
  CREATE_REMINDER_DATE_TIME = "program.timeline.create.reminder.date.time.label",
  ENABLE_SNIPPET_CONFIRMATION = "program.timeline.snippet.enable.confirmation.msg",
  DISABLE_SNIPPET_CONFIRMATION = "program.timeline.snippet.disable.confirmation.msg"
}
